import { __extends, __makeTemplateObject, __values } from "tslib";
import { css } from 'emotion';
import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Nav, NavItem } from 'reactstrap';
import { Icon } from '../Icon/Icon';
var SelectNav = function (_a) {
    var _b;
    var children = _a.children, customCss = _a.customCss;
    var navigate = useNavigate();
    if (!children || children.length === 0) {
        return null;
    }
    var defaultSelectedItem = children.find(function (navItem) {
        return navItem.active === true;
    });
    var gotoUrl = function (evt) {
        var element = evt.target;
        var url = element.options[element.selectedIndex].value;
        navigate(url);
    };
    return (React.createElement("div", { className: "gf-form-select-wrapper width-20 " + customCss },
        React.createElement("label", { className: "gf-form-select-icon " + (defaultSelectedItem ? defaultSelectedItem === null || defaultSelectedItem === void 0 ? void 0 : defaultSelectedItem.icon : ''), htmlFor: "page-header-select-nav" }),
        React.createElement("select", { className: "gf-select-nav gf-form-input form-control", value: (_b = defaultSelectedItem === null || defaultSelectedItem === void 0 ? void 0 : defaultSelectedItem.url) !== null && _b !== void 0 ? _b : '', onChange: gotoUrl, id: "page-header-select-nav" }, children.map(function (navItem) {
            if (navItem.hideFromTabs) {
                // TODO: Rename hideFromTabs => hideFromNav
                return null;
            }
            return (React.createElement("option", { key: navItem.url, value: navItem.url }, navItem.text));
        }))));
};
var Navigation = function (_a) {
    var children = _a.children;
    if (!children || children.length === 0) {
        return null;
    }
    var goToUrl = function (index) {
        return children[index] ? children[index].url || '' : '';
    };
    var getIcon = function (icon) {
        if (typeof icon == 'string') {
            return React.createElement(Icon, { name: icon || '', className: "mr-1" });
        }
        else {
            return icon;
        }
    };
    return (React.createElement("div", null,
        React.createElement(SelectNav, { customCss: "page-header__select-nav", children: children }),
        React.createElement(Nav, { tabs: true, className: "page-header__tabs" }, children.map(function (child, index) {
            return (!child.hideFromTabs && (React.createElement(NavItem, { key: "child-" + index },
                React.createElement(NavLink, { className: "nav-link", to: goToUrl(index) },
                    getIcon(child.icon),
                    child.text))));
        }))));
};
var PageHeader = /** @class */ (function (_super) {
    __extends(PageHeader, _super);
    function PageHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getIcon = function (icon, iconClassName) {
            if (typeof icon == 'string') {
                return React.createElement(Icon, { name: icon || 'apps', size: "3x", className: iconClassName });
            }
            else {
                return icon;
            }
        };
        return _this;
    }
    PageHeader.prototype.renderTitle = function (title, breadcrumbs) {
        var e_1, _a;
        if (!title && (!breadcrumbs || breadcrumbs.length === 0)) {
            return null;
        }
        if (!breadcrumbs || breadcrumbs.length === 0) {
            return React.createElement("h1", { className: "page-header__title" }, title);
        }
        var breadcrumbsResult = [];
        try {
            for (var breadcrumbs_1 = __values(breadcrumbs), breadcrumbs_1_1 = breadcrumbs_1.next(); !breadcrumbs_1_1.done; breadcrumbs_1_1 = breadcrumbs_1.next()) {
                var bc = breadcrumbs_1_1.value;
                if (bc.url) {
                    breadcrumbsResult.push(React.createElement(Link, { className: "text-link", key: breadcrumbsResult.length, to: bc.url }, bc.title));
                }
                else {
                    breadcrumbsResult.push(React.createElement("span", { key: breadcrumbsResult.length },
                        " / ",
                        bc.title));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (breadcrumbs_1_1 && !breadcrumbs_1_1.done && (_a = breadcrumbs_1.return)) _a.call(breadcrumbs_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        breadcrumbsResult.push(React.createElement("span", { key: breadcrumbs.length + 1 },
            " / ",
            title));
        return React.createElement("h1", { className: "page-header__title" }, breadcrumbsResult);
    };
    PageHeader.prototype.renderHeaderTitle = function (main) {
        var _a;
        var iconClassName = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-top: 14px;\n    "], ["\n      margin-top: 14px;\n    "])));
        return (React.createElement("div", { className: "page-header__inner" },
            React.createElement("span", { className: "page-header__logo" },
                main.icon && this.getIcon(main.icon, iconClassName),
                main.img && React.createElement("img", { alt: "logo", className: "page-header__img", src: main.img })),
            React.createElement("div", { className: "page-header__info-block" },
                this.renderTitle(main.text, (_a = main.breadcrumbs) !== null && _a !== void 0 ? _a : []),
                main.subTitle && React.createElement("div", { className: "page-header__sub-title" }, main.subTitle))));
    };
    PageHeader.prototype.render = function () {
        var model = this.props.model;
        if (!model) {
            return null;
        }
        var main = model.main;
        var children = main.children;
        return (React.createElement("div", { className: "page-header-canvas" },
            React.createElement("div", { className: "page-container" },
                React.createElement("div", { className: "page-header" },
                    this.renderHeaderTitle(main),
                    children && children.length && React.createElement(Navigation, { children: children })))));
    };
    return PageHeader;
}(React.Component));
export { PageHeader };
var templateObject_1;
//# sourceMappingURL=PageHeader.js.map